import axios from "axios";

const instance = axios.create({
  //baseURL: "http://192.168.20.31:9065/api",
  baseURL: "https://apifest.oasysben.com/public/api",
  headers: {
    'Content-Type': 'application/json'
  }
});
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default instance;